// ScalePrototype > ScalePrototype
import { IScaleData } from './IScaleData'
import { ScaleError } from './Error'

export default class ScalePrototype implements IScaleData {
	private _totalInScale: number
	constructor(private _min: number, private _max: number, private _increment: number) {
		if (_max < _min) throw new ScaleError(`max needs to be greater than min:\nmax:${_max}\nmin:${_min}`)
		if ((_max - _min) / this._increment < 1)
			throw new ScaleError(
				`scale should have at least one full increment:\nmax:${_max}\nmin:${_min}\nincrement:${_increment}`
			)

		this._totalInScale = this._calcTotalInScale()
	}

	get min(): number {
		return this._min
	}

	get max(): number {
		return this._max
	}

	get increment(): number {
		return this._increment
	}

	/**
	 * calculates the total number of increments available in the scale and rounds down to the closest integer
	 */
	get totalIncrements(): number {
		return Math.floor((this._max - this._min) / this._increment)
	}

	public expandPositive(by: number) {
		this._max = this._max + Math.floor(this._totalInScale * by)
		this._totalInScale = this._calcTotalInScale()
	}

	public expandNegative(by: number) {
		this._min = this._min - Math.ceil(this._totalInScale * by)
		this._totalInScale = this._calcTotalInScale()
	}

	private _calcTotalInScale(): number {
		return Math.floor((this._max - this._min) / this._increment)
	}
}
